import React from "react";
import { Paper, Stack, Typography, Collapse } from "@mui/material";
import { useTranslation } from "react-i18next";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

export const ValidationPopper = ({ open, value = "", absolute = false }) => {
    const { t } = useTranslation();
    const rules = [
        { label: t("validation:username-min-length"), isValid: value.length >= 3 },
        { label: t("validation:username-letter"), isValid: /^[A-Za-z]/.test(value) },
        { label: t("validation:username-characters"), isValid: /^[A-Za-z0-9_.\-]+$/.test(value) },
    ];
    
    const allValid = rules.every(r => r.isValid);

    return (
        <Collapse
            in={open}
            unmountOnExit
            sx={
                absolute
                    ? {
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        width: "100%",
                        zIndex: 10,
                    }
                    : {}
            }
        >
            <Paper
                elevation={3}
                sx={{
                    position: "relative",
                    mt: 1.5,
                    p: 2,
                    borderRadius: "8px",
                    border: "1px solid #E5E7EB",
                    boxShadow: "0px 10px 15px -3px rgba(0, 0, 0, 0.1)",
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        top: "-6px",
                        left: "24px",
                        width: "10px",
                        height: "10px",
                        backgroundColor: "#fff",
                        transform: "rotate(45deg)",
                        borderLeft: "1px solid #E5E7EB",
                        borderTop: "1px solid #E5E7EB",
                    },
                }}
            >
                <Stack spacing={1.5}>
                    {rules.map((rule) => (
                        <Stack direction="row" alignItems="center" spacing={1.5} key={rule.label}>
                            {rule.isValid ? (
                                <CheckCircleIcon sx={{ fontSize: 18, color: "#4CAF50" }} />
                            ) : (
                                <RadioButtonUncheckedIcon sx={{ fontSize: 18, color: "#D1D5DB" }} />
                            )}
                            <Typography sx={{ fontSize: "14px", color: "#374151" }}>
                                {rule.label}
                            </Typography>
                        </Stack>
                    ))}
                </Stack>
            </Paper>
        </Collapse>
    );
};
